import React, { useState } from "react";

import { Button } from "@mui/material";
import { DateRange } from "@mui/icons-material";
import { PalletPickupFormDialog } from "./pallet-pickup-form-dialog";

export const PalletPickupFormWidget = () => {
    const [shouldOpenPalletPickupFormDialog, setShouldOpenPalletPickupFormDialog] = useState(false);

    return <>
            <Button onClick={() => setShouldOpenPalletPickupFormDialog(true)}
                           data-testid={"pallet-schedule-icon"}
                           variant={"outlined"}
                           size={"large"}>
                <DateRange />
            </Button>
            {shouldOpenPalletPickupFormDialog && <PalletPickupFormDialog openOnStartup={false} onDialogClose={() => setShouldOpenPalletPickupFormDialog(false)}/>}
        </>;
};
